const { locales } = require('@sizeid/shared/lib/translation');

const localSubPaths = {};

locales.forEach(lang => {
  localSubPaths[lang] = lang;
});

module.exports = localSubPaths;
